/**
 * Centralised role checks. Update here once when adding new privileged roles.
 */
export type Role = string | undefined | null;

const PRIVILEGED = new Set(["admin", "dev"]);
const STAFF = new Set(["barista", "admin", "dev"]);
// Only `dev` keeps full access when the cafe is closed. Admins follow the
// same closed-state UX as users so they see what customers see.
const CLOSURE_BYPASS = new Set(["dev"]);

/** Bypass the cafe-closed redirect — only `dev` keeps full access regardless of hours. */
export function canBypassClosure(role: Role): boolean {
  return role ? CLOSURE_BYPASS.has(role) : false;
}

/** Generic admin gate (admin or dev). */
export function isAdminLike(role: Role): boolean {
  return role ? PRIVILEGED.has(role) : false;
}

/** Anyone working at the cafe — barista, admin, or dev. */
export function isStaff(role: Role): boolean {
  return role ? STAFF.has(role) : false;
}
